// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"96":"1c2cd8c4","391":"deab3a6c","428":"5eccd70c","561":"29177130","565":"55e10965","591":"138feaec","846":"cf9edeff","956":"3481ab24","977":"659fe836","981":"4d00b4f3"}[chunkId] + ".js";
};